import React, { useEffect, useState, useContext } from 'react';
import { useForm } from 'react-hook-form';
import { useNavigate, useParams } from 'react-router-dom';
import Form from 'react-bootstrap/Form';
import Stack from '@mui/material/Stack';
import Button from '@mui/material/Button';
import CircularProgress from '@mui/material/CircularProgress';
import TextField from '@mui/material/TextField';
import FormControl from '@mui/material/FormControl';
import Swal from 'sweetalert2';
import { getRequest, postRequest } from '../../lib/api';
import { AuthContext } from '../../authContext/context';

const SetEmail = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const authCtx = useContext(AuthContext);
  const [loading, setLoading] = useState(false);

  const {
    register,
    handleSubmit,
    setValue,
    formState: { errors },
  } = useForm();

  useEffect(() => {
    const fetchData = async () => {
      try {
        const res = await postRequest(`private/getIndivideualEmailAndPhoneNumber/${id}`,{}, authCtx.token);
        if (res?.status === 200) {
          setValue('email', res?.data?.email || '');
        }
      } catch (error) {
        Swal.fire('Error', 'Failed to fetch email', 'error');
      }
    };
    fetchData();
  }, [id, setValue, authCtx.token]);

  const onSubmit = async (data) => {
    setLoading(true);
    try {
      const res = await postRequest(`private/changeEmailAndPhone/${id}`, { email: data.email }, authCtx.token);
      if (res?.status === 200) {
        Swal.fire('Success', 'Email updated successfully', 'success');
        navigate(-1);
      } else {
        Swal.fire('Error', res?.message || 'Update failed', 'error');
      }
    } catch (error) {
      Swal.fire('Error', error?.message || 'Something went wrong', 'error');
    } finally {
      setLoading(false);
    }
  };

  return (
    <>
      <div className="page-header">
        <h1 className="mt-0">Set Email Address</h1>
      </div>
      <div className="page-top-formview mb-3">
        <Form onSubmit={handleSubmit(onSubmit)}>
          <Form.Group className="mb-3">
            <FormControl sx={{ my: 1, width: '100%' }} variant="outlined">
              <TextField
                label="Email Address"
                 InputLabelProps={{ shrink: true }}
                variant="outlined"
                {...register('email', {
                  required: 'Email is required',
                  pattern: {
                    value: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
                    message: 'Invalid email format',
                  },
                })}
                error={!!errors.email}
                helperText={errors.email?.message}
              />
            </FormControl>
          </Form.Group>

          <Stack spacing={2} direction="row">
            <Button variant="outlined" className="red-outline-btn text-capitalize" onClick={() => navigate(-1)}>
              Cancel
            </Button>
            <Button type="submit" variant="contained" className="red-bg red-button text-capitalize" disabled={loading}>
              {loading ? <CircularProgress size={20} color="inherit" /> : 'Submit'}
            </Button>
          </Stack>
        </Form>
      </div>
    </>
  );
};

export default SetEmail;
